module.exports = __webpack_public_path__ + "img/icon-left-font-tight.8ea46e1b.png";